module.exports = __webpack_public_path__ + "img/full7-min.3b31653f.png";